import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chart as ChartJS, registerables } from 'chart.js';
// time スケールに必要な日付アダプタ（chart.js v4 は内蔵しないため明示的に読み込む）
import 'chartjs-adapter-date-fns';
import { Chart } from 'vue-chartjs';
import type { LineChartProps } from 'src/models/chart';

// chart.js v3+ はツリーシェイク方式のため、利用するコントローラ・要素・スケール・プラグインを登録する
interface Props {
  chartData: LineChartProps;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LineChart',
  props: {
    chartData: {}
  },
  setup(__props: any) {

ChartJS.register(...registerables);

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), {
    type: "line",
    data: props.chartData.data,
    options: props.chartData.opts
  }, null, 8, ["data", "options"]))
}
}

})